import { Card, useTheme } from '@mui/material';
import { FlexContainer } from '../../ContentContainers/FlexContainer';
import { FullScreenPage } from './FullScreenPage';
import { ReemaLogoComponent } from '../../../display/Svg/ReemaLogoComponent';
import { PropsWithChildren } from 'react';

export interface SingleCardPageProps extends PropsWithChildren {
  showReemaLogo?: boolean;
  showBorderTop?: boolean;
}

export const SingleCardPage = ({
  showReemaLogo = false,
  showBorderTop = true,
  children,
}: SingleCardPageProps) => {
  const theme = useTheme();

  return (
    <FullScreenPage showBorderTop={showBorderTop}>
      <Card
        sx={{ padding: '32px 32px 16px', width: '100%', maxWidth: '540px' }}
      >
        <FlexContainer direction="column" alignItems="center" maxWidth="100%">
          {showReemaLogo && (
            <ReemaLogoComponent
              sx={{
                color: theme.palette?.primaryAccent?.main,
                width: '100%',
                maxWidth: '300px',
                height: 'auto',
              }}
            />
          )}
          <FlexContainer
            direction="column"
            alignItems="center"
            gap={2}
            padding="16px 32px"
          >
            {children}
          </FlexContainer>
        </FlexContainer>
      </Card>
    </FullScreenPage>
  );
};
